<template>
  <div>
        <div class="position-relative">
      <img class="about-bg" src="https://images.unsplash.com/photo-1588416681455-3f2ba669371d?ixid=MnwxMjA3fDB8MHxwaG90by
      1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80" alt="關於我們">
      <div class="about-mask d-flex align-items-center justify-content-center">
        <h2 class="font-xl text-white fw-bold">關於我們</h2>
      </div>
    </div>
    <section class="bg-light py-6">
        <div class="container">
            <div class="row bg-white mb-5">
                <div class="col-md-6 col-lg-5 px-4 py-4 pt-md-8 px-md-6 pb-md-6 d-flex
                flex-column justify-content-center">
                    <div class="d-flex flex-column">
                      <h2 class="font-md-xl fw-bold text-primary mb-5">關於 TOB</h2>
                      <p>TOB 創立於2021年，是專注在販售男性鞋類的代購公司。創立宗旨在為喜愛鞋子的男性顧客，我們提供了
                        可挑選多種鞋類的網路購物平台，讓顧客不用實際到店面去觀看，就可直接透過網路來收尋您要的鞋子。
                      </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7 px-0">
                    <img src="https://images.unsplash.com/photo-1581327390731-312ec8f2a7dc?ixid=MnwxMjA3fDB8MH
                    xwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1576&q=80"
                    class="about-size">
                </div>
            </div>
            <div class="row bg-white">
                <div class="col-md-6 col-lg-7 px-0 order-2 order-md-1">
                  <img src="https://images.unsplash.com/photo-1527181260677-e6943cf5738f?ixid=MnwxMjA3fDB8MHxw
                  aG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80"
                  class="about-size-m">
                </div>
                <div class="col-md-6 col-lg-5 px-4 py-4 pt-md-8 px-md-6 pb-md-6 d-flex flex-column
                justify-content-center order-1 order-md-2">
                    <div class="d-flex flex-column">
                      <h2 class="font-md-xl fw-bold text-primary mb-5">公司理念</h2>
                      <p>TOB 是對於喜愛鞋子的一群合夥人所創立的公司。我們透過國外進貨再利用網購的方式，目的就是想讓喜愛鞋子的男性顧客們
                        讓大家能夠簡單及輕鬆的獲得國外獨有的款式及便宜的價格。
                      </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'About',
};
</script>
